import React from 'react';
import Layout from '../layout/Layout';
import Typography from '@material-ui/core/Typography';

import Head from './components/Head';
import TextContents from './components/TextContents'

const About = (props) => {

  return (
    <Layout>

      <Head
        title="About"
        
      />

      <TextContents>
 
        <Typography paragraph variant="body1" component="p">
          Many urgent policy issues concerning the control and elimination of neglected tropical diseases (NTDs) can only be answered through high-quality quantitative modelling. 
        </Typography>
        <Typography paragraph variant="body1" component="p">
          However, a dearth of modelling in this area prevents donors and policymakers from accessing existing expertise. The NTD Modelling Consortium acts as a point of contact to commission modelling to address the right questions. The Consortium is also a conduit for the exchange of ideas, insights and questions between modellers and their users. 
        </Typography>
        <Typography paragraph variant="body1" component="p">
          Various factors motivated the creation of the NTD Modelling Consortium:
        </Typography>
        <Typography paragraph variant="body1" component="p">
          — Mathematical modelling for infectious diseases and public health works best through collaborations with epidemiologists, policymakers and field experts.
          </Typography>
        <Typography paragraph variant="body1" component="p">
          — Multiple modelling groups working on the same question allows us to investigate model structure uncertainty – the importance of particular underlying assumptions of each model type.
          </Typography>
        <Typography paragraph variant="body1" component="p">
          — The need for structures that connect modellers and users. Designing and parameterising models raise questions about underlying biology, data availability and implementation policy structures. Conversations between these different sectors will help identify the need for studies to address key uncertainties.
          </Typography>
        <Typography paragraph variant="body1" component="p"> 
         — NTD modelling lags behind modelling for other infectious diseases and it needs to be able to access the huge advances in the broader modelling field. With the right funding framework and the right relationship between modellers and users, new insight into NTDs will be possible.
          </Typography>
        <Typography paragraph gutterBottom variant="body1" component="p">
            — A recruitment problem: many modellers work on NTDs for a short amount of time due to lack of funding and limited impact of publications, again as a result of the small modelling community. We need mechanisms to attract and keep infectious disease modellers in this area.
        </Typography>
        <Typography gutterBottom variant="h3"><br />The Secretariat</Typography>
        <Typography paragraph variant="body1" component="p">
          The secretariat coordinates interactions between NTD MC members and external stakeholders, as well as promoting dialogue among consortium members themselves. The secretariat manages the consortium research agenda and priorities, which includes coordinating research outcomes and outputs and, the dissemination of the results to a broader audience.
        </Typography>
        <Typography paragraph gutterBottom variant="body1" component="p">
          The NTD Modelling Consortium is led by Professor Déirdre Hollingsworth (Big Data Institute, University of Oxford) and Professor Graham Medley (London School of Hygiene and Tropical Medicine)
        </Typography>
        <Typography paragraph variant="body1" component="p">
          The NTD MC secretariat is formed by:
        </Typography>
        <Typography paragraph variant="body1" component="p">
        <a href="javascript:location='mailto:\u0062\u0065\u0074\u0068\u002e\u0062\u0072\u0075\u0063\u0065\u0040\u0062\u0064\u0069\u002e\u006f\u0078\u002e\u0061\u0063\u002e\u0075\u006b';void 0">Beth Bruce</a>  (Big Data Institute, University of Oxford)<br />
        <a href="javascript:location='mailto:\u006a\u006f\u0061\u006f\u002e\u0072\u0065\u0069\u0073\u0040\u0062\u0064\u0069\u002e\u006f\u0078\u002e\u0061\u0063\u002e\u0075\u006b';void 0">João Reis</a> (Big Data Institute, University of Oxford)<br />
        <a href="javascript:location='mailto:\u0061\u006e\u0064\u0072\u0065\u0069\u0061\u002e\u0076\u0061\u0073\u0063\u006f\u006e\u0063\u0065\u006c\u006f\u0073\u0040\u0062\u0064\u0069\u002e\u006f\u0078\u002e\u0061\u0063\u002e\u0075\u006b';void 0">Dr Andreia Vasconcelos</a> (Big Data Institute, University of Oxford)<br />
        </Typography>
        <Typography gutterBottom variant="h3"><br />Members</Typography>
        <Typography paragraph variant="body1" component="p">
          The consortium has been brought together to support the global drive to reduce the burden of neglected tropical diseases (NTDs) by providing modelling estimates of the epidemiological impact of control strategies. It is a large international modelling effort with at least two modelling groups working on 7 of the 10 diseases in the London Declaration on NTDs. 
          The current members of the NTD Modelling Consortium are:
        </Typography>
        <Typography paragraph variant="body1" component="p">
          <a href="http://www.case.edu/">Case Western Reserve University</a><br />
          <a href="https://www6.erasmusmc.nl/public-health/?lang=en&amp;reason=404">Erasmus University Medical Center</a><br />
          <a href="http://www.imperial.ac.uk/">Imperial College London</a><br />
          <a href="http://www.lstmed.ac.uk/">Liverpool School of Tropical Medicine</a><br />
          <a href="http://www.lshtm.ac.uk/">London School of Hygiene & Tropical Medicine</a><br />
          <a href="https://www.swisstph.ch/en/">Swiss Tropical and Public Health Institute</a><br />
          <a href="https://www.ucsf.edu/">University of California, San Francisco</a><br />
          <a href="http://chicas.lancaster-university.uk/projects/ntd_consortium.html">University of Lancaster</a><br />
          <a href="https://www.nd.edu/">University of Notre Dame</a><br />
          <a href="https://www.bdi.ox.ac.uk/">University of Oxford</a><br />
          <a href="https://warwick.ac.uk/">University of Warwick</a><br />
        </Typography>
        <Typography gutterBottom variant="h3"><br />Contact Us</Typography>
          
        <Typography paragraph variant="body1" component="p">

          We welcome feedback about our website and about the work of the NTD Modelling Consortium. Please contact us for more information.<br />
          <br /><a href="javascript:location='mailto:\u0064\u0065\u0069\u0072\u0064\u0072\u0065\u002e\u0068\u006f\u006c\u006c\u0069\u006e\u0067\u0073\u0077\u006f\u0072\u0074\u0068\u0040\u0062\u0064\u0069\u002e\u006f\u0078\u002e\u0061\u0063\u002e\u0075\u006b';void 0">Professor Déirdre Hollingsworth</a><br />
          University of Oxford<br />
          <br />
          <a href="javascript:location='mailto:\u0062\u0065\u0074\u0068\u002e\u0062\u0072\u0075\u0063\u0065\u0040\u0062\u0064\u0069\u002e\u006f\u0078\u002e\u0061\u0063\u002e\u0075\u006b';void 0">Beth Bruce</a><br />
          University of Oxford<br />
          <br />
          Big Data Institute<br />
          University of Oxford<br />
          Old Road Campus<br />
          Headington<br />
          Oxford<br />
          OX3 7LF<br />
        </Typography>

      </TextContents>
    </Layout>
  )
}
export default About;
